import { authRequest } from './client';
import {
  type FireblocksEventDetailResponse,
  type ListFireblocksEventsParams,
  type ListFireblocksEventsResponse,
} from './types';

// ─── backoffice-api fireblocks-events client ───────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/fireblocks-events`
// endpoints (Task 30 — raw custody provider events, read-only). Both
// require TECH_VIEWER (or SUPERADMIN). `eventType`/`resourceId` are
// free-text filters (no fixed enum vocabulary on the backend DTO).

export function listFireblocksEvents(
  params: ListFireblocksEventsParams = {},
): Promise<ListFireblocksEventsResponse> {
  const query = new URLSearchParams();

  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.eventType !== undefined) query.set('eventType', params.eventType);
  if (params.resourceId !== undefined) query.set('resourceId', params.resourceId);
  if (params.from !== undefined) query.set('from', params.from);
  if (params.to !== undefined) query.set('to', params.to);

  const qs = query.toString();
  return authRequest<ListFireblocksEventsResponse>(`/fireblocks-events${qs ? `?${qs}` : ''}`);
}

export function getFireblocksEvent(id: string): Promise<FireblocksEventDetailResponse> {
  return authRequest<FireblocksEventDetailResponse>(`/fireblocks-events/${id}`);
}
